import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../Components/Media/AudioButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import { unicodeToString } from "../../Js/Common";
import Slide from "@mui/material/Slide";

const style = {
  position: "absolute",
  top: "30%",
  left: "40%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const ContextInfoModal = (props) => {
  const containerRef = React.useRef(null);
  let [initialRender, setInitialRender] = useState(true);
  let [isPlaying, setIsPlaying] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "primary.main",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item>
                {props.word && (
                  <>
                    <Typography
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                      variant="h5"
                    >
                      {props.word}
                    </Typography>
                    <Typography sx={{ color: "#ffffff", fontStyle: "italic" }}>
                      explanation
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid item>
                {props.audio && (
                  <AudioButton
                    expertAudio={props.audio}
                    playStatus={(status) => setIsPlaying(status)}
                  >
                    <IconButton
                      sx={{
                        color: "#DB8829",
                        backgroundColor: "#FFFFFF",
                        mx: 1,
                        padding: 0,
                       
                      }}
                    >
                      {isPlaying && (
                        <PauseIcon
                          sx={{
                            borderRadius: "50%",
                            padding: 1,
                            color: "#DB8829",
                            "@media (min-width: 1636px)": {
                              fontSize: "2.2rem",
                            },
                          }}
                        />
                      )}
                      {!isPlaying && (
                        <MusicNoteIcon
                          sx={{
                            borderRadius: "50%",
                            padding: 1,
                            "@media (min-width: 1636px)": {
                              fontSize: "2.2rem",
                            },
                          }}
                        />
                      )}
                    </IconButton>
                  </AudioButton>
                )}
              </Grid>
              {props.meaning && (
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignContent: "center",
                    alignItems: "center",
                    pt: 5,
                  }}
                >
                  <Typography sx={{ color: "#ffffff" }}>
                    {unicodeToString(props.meaning)}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
});
export default ContextInfoModal;
